export const statusPO = {
    RUNNING: 'RUNNING',
    DELETED: 'DELETED',
    CLOSED: 'CLOSED',
};
